import React, { useState } from 'react';
import './index.css';
import Image from 'react-bootstrap/Image';
import donut_light from '../../assets/accounts-section/Donut-light.png'
import donut_dark from '../../assets/accounts-section/Donut-light-big.png'
import Navbar from '../../Components/Navbar/Navbar';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import Genie from '../../assets/accounts-section/Genie.png';
import { toast } from 'react-toastify';
import { useNotification } from '../../Context/NotificationContext';

const config = require("../../Helpers/config.json");

const ResetPasswordUser = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const email = location?.state?.email;
    const otp = location?.state?.otp;
    const { showNotification } = useNotification();
    const [newPassword, setNewPassword] = useState(null);
    const [confirmPassword, setConfirmPassword] = useState(null);
    const [loading, setLoading] = useState(false);

    const reset = () => {
        if (!newPassword || !confirmPassword) {
            toast.warning('Password field is empty!', {
                position: 'top-center',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
        } else if (newPassword !== confirmPassword) {
            toast.warning("Password doesn't match!", {
                position: 'top-center',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
        } else if (newPassword === confirmPassword) {
            setLoading(true);
            fetch(`${config['baseUrl2']}v1/password-resets`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify({
                    token: otp,
                    newPassword: newPassword
                }),
            })
                .then((res) => {
                    setLoading(false);
                    if (res.ok || res.status === 204) {
                        toast.success('Password reset successfully');
                        navigate('/signin');
                    } else {
                        res.json().then(data => {
                            showNotification({
                                title: 'Reset Failed',
                                message: data.error?.message || 'Password reset failed',
                                type: 'error'
                            });
                        }).catch(() => {
                            showNotification({
                                title: 'Reset Failed',
                                message: 'Password reset failed',
                                type: 'error'
                            });
                        });
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    console.error('Error:', err);
                    showNotification({
                        title: 'Error',
                        message: 'An error occurred during password reset.',
                        type: 'error'
                    });
                });
        }
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            reset();
        }

    };
    return (
        <div className='reset-main-container'>

            <img src={donut_light} className='light-donut-login' />
            <img src={donut_dark} className='dark-donut-login' />
            {loading && (
                <div className="loader-overlay">
                    <div className="loader" />
                </div>
            )}
            <Navbar />
            <div className="main-wrap">
                <div className="sub-wrap">
                    <div className="reset-form">
                        <div className="reset-heading">
                            <h2>Reset Password</h2>
                        </div>
                        <div className="custom-reset-form">
                            <input
                                className='form-control crediantal-fields'
                                type="password"
                                placeholder="New Password"
                                onKeyDown={handleKeyDown}

                                onChange={(e) => setNewPassword(e.target.value)} // Update the new password state
                            />
                            <input
                                className='form-control crediantal-fields'
                                type="password"
                                placeholder="Confirm Password"
                                onKeyDown={handleKeyDown}
                                onChange={(e) => setConfirmPassword(e.target.value)} // Update the confirm password state
                            />
                        </div>
                        <div className='subline-wrap'>
                            <p style={{ textAlign: "center" }} className='subline'>Already have an account? <span className='redirect'> <NavLink to='/signin'>Login here!</NavLink></span> </p>
                        </div>
                        <div className='Btn-wrap'>
                            <button className='Btn' onClick={reset}>Reset</button> {/* Call reset on button click */}
                        </div>
                    </div>
                    <div className="reset-image">
                        <div className="animated-image">
                            <Image src={Genie} fluid className="blurred-shadow" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordUser;
